var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSize43 = function SvgIconSize43(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    x: 0.5,
    y: 1,
    stroke: "#777E90",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M8.076 14.424v-1.416l3.636-5.484.804.636-3.396 5.136.108.216h5.664v.912zm4.572 2.076v-6.204h1.08V16.5zm3.427 0v-1.464h1.392V16.5zm0-4.44v-1.464h1.392v1.464zm5.853 4.656q-.984 0-1.668-.384a2.67 2.67 0 0 1-1.044-1.02 2.8 2.8 0 0 1-.348-1.38h1.128q0 .816.516 1.296.528.48 1.416.48.588 0 1.02-.216t.672-.612q.24-.408.24-.948 0-.816-.528-1.32-.516-.504-1.392-.504-.372 0-.648.096a2 2 0 0 0-.468.216l-.576-1.032 3.348-2.448-.12-.216h-4.26V7.74h5.34v1.596l-2.772 2.016-.84.036a3 3 0 0 1 .444-.12q.252-.048.588-.048.96 0 1.632.36t1.02.96q.36.6.36 1.308v.168q0 .696-.36 1.32-.348.612-1.032.996-.672.384-1.668.384"
  })));
};
export default SvgIconSize43;